import { types } from '../page/Chapter'

export const ThirdData: types = [
  {
    id: 1,
    date: '',
    problem: '',
    state: '',
    result: [''],
  },
]
